export default {
  title: 'Projection patrimoniale',
  subtitle:
    'Simulation prenant en compte votre patrimoine financier et immobilier',
  tooltip:
    "Simulation à horizon 20 ans, tenant compte de vos remboursements de crédits, de votre épargne programmée et d'une performance en corrélation avec l'exposition en risque de vos placements",
  display: {
    chart: 'Cône de projection',
    simplified: 'Vue simplifiée',
    gainLoss: 'Gains et pertes potentiels',
  },
  simplified: {
    dottedLine1: 'PATRIMOINE',
    dottedLine2: 'INITIAL',
    tooltip: 'probabilité de {percent}',
    label: {
      optimistic80: 'optimiste',
      optimistic95: 'très optimiste',
      pessimistic80: 'pessimiste',
      pessimistic95: 'très pessimiste',
    },
  },
  gainLoss: {
    toYears: 'À {year} an|À {year} ans',
    contribution: 'Cumul de vos versements',
    performanceMedium: 'Performance moyenne attendue',
    performanceLow: 'Mauvaise performance possible',
    diffToContribution: 'Cumul avec vos versements',
    crisis: 'Scénario de crise financière pour un profil similaire',
  },
  chart: {
    legend: {
      crisis: 'Scénario crise financière et/ou immobilière',
      initialNet: 'Projection du patrimoine net initial',
      maxOptimistic80: 'Scénario central (Probabilité de {percent})',
      maxOptimistic95: 'Scénario favorable (Probabilité de {percent})',
      maxPessimistic80: 'Scénario défavorable (Probabilité de {percent})',
    },
  },
}
